import { Button, Stack, Typography } from '@mui/material';
import { AtLocator } from '@Components/shared/locators/AtLocator';
import { useFreebetsTable } from '@Modal/hooks/freebets/useFreebetsTable';

export const FreebetsTitle: React.FC = () => {
  const { freebetTableFilters, handleClearFreebetTableFilters } = useFreebetsTable();
  const objectVals = Object.values(freebetTableFilters);
  const disabled = objectVals.length === 0 || objectVals.every((val) => val === undefined);

  return (
    <AtLocator type="container" name="FreebetsTitle">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ paddingBottom: 2 }}
      >
        <Typography variant="h3">Freebets</Typography>
        <AtLocator type="button" name="clearFilters">
          <Button
            size="large"
            variant="contained"
            disabled={disabled}
            onClick={handleClearFreebetTableFilters}
          >
            Clear filters
          </Button>
        </AtLocator>
      </Stack>
    </AtLocator>
  );
};
